import { render, staticRenderFns } from "./IrMailing.vue?vue&type=template&id=d64bb9de&"
import script from "./IrMailing.vue?vue&type=script&lang=js&"
export * from "./IrMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports